import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { ButtonItem, SegmentedItem, TableItem, TourItem } from '../../../Components/Items'
import { connect } from "react-redux";
import AgregarTipoDeActivo from "./AgregarTipoDeActivo/AgregarTipoDeActivo";
import { EditOutlined, CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import EditarTipoDeActivo from "./EditarTipoDeActivo/EditarTipoDeActivo";

const FRECUENCIAS = { 1: "Mensual", 2: "Bimestral", 3: "Trimestral", 4: "Semestral", 5: "Anual" };
const METODOS = { 1: "Línea recta" };

class TiposDeActivo extends Component {
  refTabla = React.createRef();
  state = {
    todosTiposDeActivo: [],
    modalAgregarTipoDeActivo: false,
    modalEditarTipoDeActivo: false,
    modalEditarTipoDeActivoId: null,
    loading: false,
    valor: 1,
    openTour: false,
  }
  componentDidMount() {
    this.consultarTiposDeActivo(this.state.valor);
  }

  consultarTiposDeActivo(valor) {
    this.setState({ loading: true })
    axios
      .post(
        "activosFijos/selectTiposDeActivo",
        { empresaId: this.props.empresaId, valor: valor },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (!Array.isArray(res.data)) {
          this.setState({ todosTiposDeActivo: [] });
        } else {
          this.setState({
            todosTiposDeActivo: res.data.map(value => {
              return { ...value, accion: { _id: value._id, estado: value.estado } }
            }),
          });
        }
      });
  }
  deshabilitarTipoDeActivo(value) {
    axios
      .post(
        "activosFijos/deshabilitarTipoDeActivo",
        { familiaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de Activo deshabilitado");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        this.consultarTiposDeActivo(this.state.valor);
      });
  }
  habilitarTipoDeActivo(value) {
    axios
      .post(
        "activosFijos/habilitarTipoDeActivo",
        { familiaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de Activo habilitado");
        } else {
          message.error("Sucedió un error y no se pudo habilitar");
        }
        this.consultarTiposDeActivo(this.state.valor);
      });
  }
  abrirAgregarTipoDeActivo() {
    this.setState({ modalAgregarTipoDeActivo: true });
  }
  cerrarAgregarTipoDeActivo() {
    this.setState({ modalAgregarTipoDeActivo: false });
    this.consultarTiposDeActivo(this.state.valor);
  }
  abrirEditarTipoDeActivo(id) {
    this.setState({ modalEditarTipoDeActivo: true, modalEditarTipoDeActivoId: id });
  }
  cerrarEditarTipoDeActivo() {
    this.setState({ modalEditarTipoDeActivo: false });
    this.consultarTiposDeActivo(this.state.valor);
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => (a.nombre < b.nombre ? -1 : a.nombre > b.nombre ? 1 : 0),
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
      },
      {
        title: "Método",
        dataIndex: "metodoDepreciacionDefault",
        key: "metodoDepreciacionDefault",
        render: (value) => METODOS[value] || "-",
      },
      {
        title: "Frecuencia",
        dataIndex: "frecuenciaDepreciacionDefault",
        key: "frecuenciaDepreciacionDefault",
        render: (value) => FRECUENCIAS[value] || "-",
      },
      {
        title: "Depreciación Anual (%)",
        dataIndex: "porcentajeDepreciacionAnualDefault",
        key: "porcentajeDepreciacionAnualDefault",
        render: (value) => (value != null ? `${value}%` : "-"),
      },
      {
        title: "% Residual",
        dataIndex: "valorResidualDefaultPorcentaje",
        key: "valorResidualDefaultPorcentaje",
        render: (value) => (value || value === 0 ? `${value}%` : "-"),
      },
      {
        title: "Prefijo Serie",
        dataIndex: "prefijoSerieActivo",
        key: "prefijoSerieActivo",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: 'center', padding: '4px' } }),
        render: (value, index) => {
          let buttons = [];
          if (this.props.permisoEditarTipoDeActivo) {
            buttons.push(
              <Tooltip key={`editar-${index}`} title="Editar Tipo de Activo" placement="top">
                <ButtonItem
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarTipoDeActivo(value._id)}
                />
              </Tooltip>
            );
          }
          if (this.props.permisoDeshabilitarTipoDeActivo) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar este Tipo de Activo"
                  onConfirm={() => this.deshabilitarTipoDeActivo(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top">
                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar este Tipo de Activo"
                  onConfirm={() => this.habilitarTipoDeActivo(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top">
                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            }
          }
          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ]
    return (
      <>
        <PageHeader
          title="Tipos de Activo"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Activo', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 3 }]}
                  onChange={(value) => {
                    this.consultarTiposDeActivo(value)
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              {this.props.permisoAgregarTipoDeActivo &&
                <ButtonItem
                  type="primary"
                  key="agregarTipoDeActivo"
                  onClick={this.abrirAgregarTipoDeActivo.bind(this)}
                  className="botonAgregar"
                >
                  Agregar Tipo de Activo
                </ButtonItem>}
              <ButtonItem type="default" blanco onClick={() => this.setState({ openTour: true })}>
                ¿Cómo funciona?
              </ButtonItem>
            </>
          }
        />
        <div ref={this.refTabla}>
          <TableItem
            loading={this.state.loading}
            size='small'
            dataSource={this.state.todosTiposDeActivo}
            columns={columns}
            onRow={(record) => ({
              onDoubleClick: () => {
                if (this.props.permisoEditarTipoDeActivo) {
                  this.abrirEditarTipoDeActivo(record._id)
                }
              },
            })}
          />
        </div>
        <AgregarTipoDeActivo
          visible={this.state.modalAgregarTipoDeActivo}
          cerrarAgregarTipoDeActivo={this.cerrarAgregarTipoDeActivo.bind(this)}
        />
        <EditarTipoDeActivo
          visible={this.state.modalEditarTipoDeActivo}
          id={this.state.modalEditarTipoDeActivoId}
          cerrarEditarTipoDeActivo={this.cerrarEditarTipoDeActivo.bind(this)}
        />
        <TourItem
          open={this.state.openTour}
          onClose={() => this.setState({ openTour: false })}
          steps={[
            {
              title: "Tipos de Activo",
              description: "Un Tipo de Activo es la categoría contable de tus activos fijos (ej. Mobiliario, Equipo de Cómputo). Define las cuentas contables y las reglas de depreciación por default que heredarán todos los Activos de ese tipo.",
              target: null,
            },
            {
              title: "Listado",
              description: "Doble clic en una fila para editar un Tipo de Activo. El botón 'Agregar Tipo de Activo' crea uno nuevo.",
              target: () => this.refTabla.current,
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarTipoDeActivo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a6952af49a8383de2bd70ad")?.activado,
    permisoEditarTipoDeActivo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a6952f049a8383de2bd712a")?.activado,
    permisoDeshabilitarTipoDeActivo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a69530249a8383de2bd712b")?.activado,
  };
};

export default connect(mapStateToProps)(TiposDeActivo);
